import { Link } from "react-router-dom";
import { Users, Bed, ArrowRight } from "lucide-react";
import { BOOKING_URL } from "../lib/config";

export default function RoomCard({ room, onOpen }) {
  return (
    <article
      className="wb-card group flex flex-col hover:shadow-xl hover:-translate-y-1 transition-[transform,box-shadow] duration-500"
      data-testid={`room-card-${room.slug}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-[#F5F0E6]">
        <img
          src={room.hero_photo}
          alt={`${room.name} at Westbridge Inn & Suites`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
          loading="lazy"
        />
        {room.is_flagship && (
          <div
            className="absolute top-3 left-3 bg-[#E85D26] text-white text-xs font-black uppercase tracking-wider px-3 py-1"
            style={{ fontFamily: "'Nunito', sans-serif" }}
            data-testid={`flagship-badge-${room.slug}`}
          >
            Flagship suite
          </div>
        )}
        <div className="absolute bottom-3 right-3 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-sm">
          <span className="text-xs text-[#4A4641] font-medium">From </span>
          <span
            className="text-base font-black text-[#B94A15]"
            style={{ fontFamily: "'Nunito', sans-serif" }}
            data-testid={`room-price-${room.slug}`}
          >
            ${room.price_from.toFixed(0)}
          </span>
          <span className="text-xs text-[#4A4641] font-medium">/night</span>
        </div>
      </div>

      <div className="p-6 flex flex-col flex-1">
        <h3 className="wb-h3" data-testid={`room-name-${room.slug}`}>
          {room.name}
        </h3>
        <p className="mt-2 text-sm text-[#B94A15] font-bold" style={{ fontFamily: "'Nunito', sans-serif" }}>
          {room.tagline}
        </p>

        <div className="mt-4 flex flex-wrap gap-4 text-xs text-[#4A4641] font-medium">
          <span className="flex items-center gap-1.5">
            <Bed className="h-3.5 w-3.5 text-[#B94A15]" />
            {room.bed_config}
          </span>
          <span className="flex items-center gap-1.5">
            <Users className="h-3.5 w-3.5 text-[#B94A15]" />
            Up to {room.max_guests}
          </span>
        </div>

        <ul className="mt-4 space-y-1 text-sm text-[#4A4641]">
          {room.features.slice(0, 4).map((f) => (
            <li key={f} className="flex items-start gap-2">
              <span className="inline-block mt-2 h-1 w-1 rounded-full bg-[#E85D26] flex-shrink-0" />
              {f}
            </li>
          ))}
        </ul>

        <div className="mt-6 pt-4 border-t border-[#E5DFD3] flex items-center gap-2 flex-1 items-end">
          <button
            onClick={() => onOpen && onOpen(room)}
            className="wb-btn-outline flex-1 text-sm py-2"
            data-testid={`room-view-${room.slug}`}
          >
            View room <ArrowRight className="h-3.5 w-3.5" />
          </button>
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="wb-btn-primary flex-1 text-sm py-2"
            data-testid={`room-book-${room.slug}`}
          >
            Book
          </a>
        </div>
      </div>
    </article>
  );
}
